// source: pbtypes/gen/shape_map/shape_map.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_shape_map_box_pb = require('../../../pbtypes/gen/shape_map/box_pb.js');
goog.object.extend(proto, pbtypes_gen_shape_map_box_pb);
var pbtypes_gen_shape_map_cylinder_pb = require('../../../pbtypes/gen/shape_map/cylinder_pb.js');
goog.object.extend(proto, pbtypes_gen_shape_map_cylinder_pb);
var pbtypes_gen_shape_map_half_plane_pb = require('../../../pbtypes/gen/shape_map/half_plane_pb.js');
goog.object.extend(proto, pbtypes_gen_shape_map_half_plane_pb);
var pbtypes_gen_shape_map_polygon_pb = require('../../../pbtypes/gen/shape_map/polygon_pb.js');
goog.object.extend(proto, pbtypes_gen_shape_map_polygon_pb);
var pbtypes_gen_shape_map_sphere_pb = require('../../../pbtypes/gen/shape_map/sphere_pb.js');
goog.object.extend(proto, pbtypes_gen_shape_map_sphere_pb);
goog.exportSymbol('proto.shape_map.ShapeMapPb', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shape_map.ShapeMapPb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.shape_map.ShapeMapPb.repeatedFields_, null);
};
goog.inherits(proto.shape_map.ShapeMapPb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shape_map.ShapeMapPb.displayName = 'proto.shape_map.ShapeMapPb';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.shape_map.ShapeMapPb.repeatedFields_ = [2,3,4,5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shape_map.ShapeMapPb.prototype.toObject = function(opt_includeInstance) {
  return proto.shape_map.ShapeMapPb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shape_map.ShapeMapPb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shape_map.ShapeMapPb.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
halfPlanesList: jspb.Message.toObjectList(msg.getHalfPlanesList(),
    pbtypes_gen_shape_map_half_plane_pb.HalfPlanePb.toObject, includeInstance),
spheresList: jspb.Message.toObjectList(msg.getSpheresList(),
    pbtypes_gen_shape_map_sphere_pb.SpherePb.toObject, includeInstance),
cylindersList: jspb.Message.toObjectList(msg.getCylindersList(),
    pbtypes_gen_shape_map_cylinder_pb.CylinderPb.toObject, includeInstance),
boxesList: jspb.Message.toObjectList(msg.getBoxesList(),
    pbtypes_gen_shape_map_box_pb.BoxPb.toObject, includeInstance),
polygonsList: jspb.Message.toObjectList(msg.getPolygonsList(),
    pbtypes_gen_shape_map_polygon_pb.PolygonPb.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shape_map.ShapeMapPb}
 */
proto.shape_map.ShapeMapPb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shape_map.ShapeMapPb;
  return proto.shape_map.ShapeMapPb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shape_map.ShapeMapPb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shape_map.ShapeMapPb}
 */
proto.shape_map.ShapeMapPb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = new pbtypes_gen_shape_map_half_plane_pb.HalfPlanePb;
      reader.readMessage(value,pbtypes_gen_shape_map_half_plane_pb.HalfPlanePb.deserializeBinaryFromReader);
      msg.addHalfPlanes(value);
      break;
    case 3:
      var value = new pbtypes_gen_shape_map_sphere_pb.SpherePb;
      reader.readMessage(value,pbtypes_gen_shape_map_sphere_pb.SpherePb.deserializeBinaryFromReader);
      msg.addSpheres(value);
      break;
    case 4:
      var value = new pbtypes_gen_shape_map_cylinder_pb.CylinderPb;
      reader.readMessage(value,pbtypes_gen_shape_map_cylinder_pb.CylinderPb.deserializeBinaryFromReader);
      msg.addCylinders(value);
      break;
    case 5:
      var value = new pbtypes_gen_shape_map_box_pb.BoxPb;
      reader.readMessage(value,pbtypes_gen_shape_map_box_pb.BoxPb.deserializeBinaryFromReader);
      msg.addBoxes(value);
      break;
    case 6:
      var value = new pbtypes_gen_shape_map_polygon_pb.PolygonPb;
      reader.readMessage(value,pbtypes_gen_shape_map_polygon_pb.PolygonPb.deserializeBinaryFromReader);
      msg.addPolygons(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shape_map.ShapeMapPb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shape_map.ShapeMapPb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shape_map.ShapeMapPb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shape_map.ShapeMapPb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getHalfPlanesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      pbtypes_gen_shape_map_half_plane_pb.HalfPlanePb.serializeBinaryToWriter
    );
  }
  f = message.getSpheresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      pbtypes_gen_shape_map_sphere_pb.SpherePb.serializeBinaryToWriter
    );
  }
  f = message.getCylindersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      pbtypes_gen_shape_map_cylinder_pb.CylinderPb.serializeBinaryToWriter
    );
  }
  f = message.getBoxesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      pbtypes_gen_shape_map_box_pb.BoxPb.serializeBinaryToWriter
    );
  }
  f = message.getPolygonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      pbtypes_gen_shape_map_polygon_pb.PolygonPb.serializeBinaryToWriter
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.shape_map.ShapeMapPb.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.shape_map.ShapeMapPb} returns this
 */
proto.shape_map.ShapeMapPb.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated HalfPlanePb half_planes = 2;
 * @return {!Array<!proto.shape_map.HalfPlanePb>}
 */
proto.shape_map.ShapeMapPb.prototype.getHalfPlanesList = function() {
  return /** @type{!Array<!proto.shape_map.HalfPlanePb>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_shape_map_half_plane_pb.HalfPlanePb, 2));
};


/**
 * @param {!Array<!proto.shape_map.HalfPlanePb>} value
 * @return {!proto.shape_map.ShapeMapPb} returns this
*/
proto.shape_map.ShapeMapPb.prototype.setHalfPlanesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.shape_map.HalfPlanePb=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shape_map.HalfPlanePb}
 */
proto.shape_map.ShapeMapPb.prototype.addHalfPlanes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.shape_map.HalfPlanePb, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shape_map.ShapeMapPb} returns this
 */
proto.shape_map.ShapeMapPb.prototype.clearHalfPlanesList = function() {
  return this.setHalfPlanesList([]);
};


/**
 * repeated SpherePb spheres = 3;
 * @return {!Array<!proto.shape_map.SpherePb>}
 */
proto.shape_map.ShapeMapPb.prototype.getSpheresList = function() {
  return /** @type{!Array<!proto.shape_map.SpherePb>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_shape_map_sphere_pb.SpherePb, 3));
};


/**
 * @param {!Array<!proto.shape_map.SpherePb>} value
 * @return {!proto.shape_map.ShapeMapPb} returns this
*/
proto.shape_map.ShapeMapPb.prototype.setSpheresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.shape_map.SpherePb=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shape_map.SpherePb}
 */
proto.shape_map.ShapeMapPb.prototype.addSpheres = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.shape_map.SpherePb, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shape_map.ShapeMapPb} returns this
 */
proto.shape_map.ShapeMapPb.prototype.clearSpheresList = function() {
  return this.setSpheresList([]);
};


/**
 * repeated CylinderPb cylinders = 4;
 * @return {!Array<!proto.shape_map.CylinderPb>}
 */
proto.shape_map.ShapeMapPb.prototype.getCylindersList = function() {
  return /** @type{!Array<!proto.shape_map.CylinderPb>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_shape_map_cylinder_pb.CylinderPb, 4));
};


/**
 * @param {!Array<!proto.shape_map.CylinderPb>} value
 * @return {!proto.shape_map.ShapeMapPb} returns this
*/
proto.shape_map.ShapeMapPb.prototype.setCylindersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.shape_map.CylinderPb=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shape_map.CylinderPb}
 */
proto.shape_map.ShapeMapPb.prototype.addCylinders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.shape_map.CylinderPb, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shape_map.ShapeMapPb} returns this
 */
proto.shape_map.ShapeMapPb.prototype.clearCylindersList = function() {
  return this.setCylindersList([]);
};


/**
 * repeated BoxPb boxes = 5;
 * @return {!Array<!proto.shape_map.BoxPb>}
 */
proto.shape_map.ShapeMapPb.prototype.getBoxesList = function() {
  return /** @type{!Array<!proto.shape_map.BoxPb>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_shape_map_box_pb.BoxPb, 5));
};


/**
 * @param {!Array<!proto.shape_map.BoxPb>} value
 * @return {!proto.shape_map.ShapeMapPb} returns this
*/
proto.shape_map.ShapeMapPb.prototype.setBoxesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.shape_map.BoxPb=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shape_map.BoxPb}
 */
proto.shape_map.ShapeMapPb.prototype.addBoxes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.shape_map.BoxPb, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shape_map.ShapeMapPb} returns this
 */
proto.shape_map.ShapeMapPb.prototype.clearBoxesList = function() {
  return this.setBoxesList([]);
};


/**
 * repeated PolygonPb polygons = 6;
 * @return {!Array<!proto.shape_map.PolygonPb>}
 */
proto.shape_map.ShapeMapPb.prototype.getPolygonsList = function() {
  return /** @type{!Array<!proto.shape_map.PolygonPb>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_shape_map_polygon_pb.PolygonPb, 6));
};


/**
 * @param {!Array<!proto.shape_map.PolygonPb>} value
 * @return {!proto.shape_map.ShapeMapPb} returns this
*/
proto.shape_map.ShapeMapPb.prototype.setPolygonsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.shape_map.PolygonPb=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shape_map.PolygonPb}
 */
proto.shape_map.ShapeMapPb.prototype.addPolygons = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.shape_map.PolygonPb, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shape_map.ShapeMapPb} returns this
 */
proto.shape_map.ShapeMapPb.prototype.clearPolygonsList = function() {
  return this.setPolygonsList([]);
};


goog.object.extend(exports, proto.shape_map);
